import styled from "styled-components";

export const ChattingBoxContainer = styled.div`
    color: blue;
    // background-color: rgba(255, 255, 255, .95);
    height: 100%;
    display: flex;
    // flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const ChattingBox = styled.div`
    background-color: white;
    width: 850px;
    max-width: 85%;
    height: 80%;
    border: solid 1px black;
    display: flex;
    flex-direction: column;
`;

export const Header = styled.div`
    color: white;
    background-color: rgba(0, 0, 0, 1);
    width: 100%;
    height: 10%;
    border-bottom: 1px solid rgba(255, 255, 255, .25);
    position: relative;
    top: 0%;

    h2 {
        margin-left: 3%;
    }
`;

export const Main = styled.div`
    width: 100%;
    height: 78%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;
    bottom: 10%;
    overflow-y: scroll;
    overflow-x: hidden;
`;

// export const Scroll = styled.div`
//     width: 100%;
//     height: auto;
//     display: flex;
//     flex-direction: column;
//     position: relative;
//     bottom: 0;
//     overflow: scroll;
// `;

export const Footer = styled.div`
    width: 100%;
    height: 12%;
    border-top: 1px solid rgba(255, 255, 255, .25);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    position: relative;
    top: 78%;
    // left: 3%;

    // input {
    //     background-color: rgba(0, 0, 0, 0.1);
    // }

    span {
        font-weight: bold;
        width: 2em;
    }
`;